import { render, staticRenderFns } from "./appoint-check.vue?vue&type=template&id=55bcc7d1"
import script from "./appoint-check.vue?vue&type=script&lang=ts"
export * from "./appoint-check.vue?vue&type=script&lang=ts"
import style0 from "./appoint-check.vue?vue&type=style&index=0&id=55bcc7d1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports